import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import { Button } from "@mui/material"

const selectedButtonClasses = "text-primary border-primary";
const defaultButtonClasses = "text-gray-600 border-slate-300 font-normal";
export const RadioButton = ({ label = "", type = "", isSelected = false, onClick = () => { }, ...otherProps }) => {

    return (
        <Button
            className={`mr-3 mb-1 py-2 px-4 capitalize bg-white ${isSelected ? selectedButtonClasses : defaultButtonClasses}`}
            variant="outlined"
            size="small"
            onClick={() => onClick(type)}
            startIcon={isSelected ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
            {...otherProps}
        >
            {label}
        </Button>
    )
}